module.exports = __webpack_public_path__ + "img/22.7.Chla.0e34a91d.png";